import axiosInstance from 'services/axiosMiddleware';

export async function getInvite(coachData) {
  try {
    const response = await axiosInstance.post('/invite/get-invite', coachData);

    console.log('response', response);

    if (response.data) {
      return {
        response: response.data
      };
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error sending invite:', error);
    throw error;
  }
}
